export default __webpack_public_path__ + "66374f54410b99acf26e3243d591ea9d.svg";